import React, { useState } from 'react';
import styled from 'styled-components';
import { Icon, BackgroundIcon } from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { Button } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { FormattedMessage } from 'react-intl';

const DefaultViewer = (props) => {
  const { url, alt, name, handleDownload, token } = props;
  return (
    <DefaultViewerContainer>
      <div className="flex-center">
        <img
          className="image"
          src={envConfig.imageRoot + 'svg/file.svg'}
          alt={''}
        />
        <span className="file-name">{name || ''}</span>
      </div>
      <div className="mt20">
        <Button
          onClick={() => {
            if (token) {
              handleDownload({
                name,
                url
              });
            } else {
              window.open(url);
            }
          }}
          icon={
            <div className="fx center mr8">
              <SVGIcon name="Download" />
            </div>
          }
        >
          <FormattedMessage id={'app.download.btn'} />
        </Button>
      </div>
    </DefaultViewerContainer>
  );
};

export default DefaultViewer;

const DefaultViewerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .download-btn {
    cursor: pointer;
    background-color: #000;
    width: 213px;
    margin-top: 20px;
    height: 56px;
  }
  .file-name {
    color: #fff;
    font-size: 24px;
    margin-left: 15px;
  }
  .image {
    height: 30px;
    width: 30px;
    object-fit: contain;
  }
  .download-label {
    color: #fff;
    text-decoration: none;
  }
  .download-icon {
    width: 25px;
    height: 35px;
    margin-right: 10px;
  }
`;
